import React from 'react';

const InventryInactiveIcon = () => {
  return (
    <svg width='25' height='25' viewBox='0 0 25 25' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g opacity='0.5'>
        <path
          opacity='0.4'
          d='M20.6 7.68998C20.6 8.22998 20.31 8.71995 19.85 8.96995L18.11 9.90995L16.63 10.7L13.56 12.36C13.23 12.54 12.87 12.63 12.5 12.63C12.13 12.63 11.77 12.54 11.44 12.36L5.14999 8.96995C4.68999 8.71995 4.39999 8.22998 4.39999 7.68998C4.39999 7.14998 4.68999 6.65995 5.14999 6.40995L7.12 5.34996L8.69 4.49998L11.44 3.02C12.1 2.66 12.9 2.66 13.56 3.02L19.85 6.40995C20.31 6.65995 20.6 7.14998 20.6 7.68998Z'
          fill='#292D32'
        />
        <path
          opacity='0.4'
          d='M10.4 13.5399L4.54999 10.6099C4.09999 10.3799 3.57999 10.4099 3.14999 10.6699C2.71999 10.9299 2.47 11.3899 2.47 11.8899V17.4199C2.47 18.3799 2.99999 19.2399 3.85999 19.6699L9.70999 22.5899C9.90999 22.6899 10.13 22.7399 10.35 22.7399C10.61 22.7399 10.87 22.6699 11.1 22.5199C11.53 22.2599 11.78 21.7999 11.78 21.2999V15.7699C11.79 14.8299 11.26 13.9699 10.4 13.5399Z'
          fill='#292D32'
        />
        <path
          opacity='0.4'
          d='M22.53 11.9002V17.4301C22.53 18.3801 22 19.2401 21.14 19.6701L15.29 22.6001C15.09 22.7001 14.87 22.7501 14.65 22.7501C14.39 22.7501 14.13 22.6802 13.89 22.5302C13.47 22.2702 13.21 21.8101 13.21 21.3101V15.7901C13.21 14.8301 13.74 13.9701 14.6 13.5401L16.75 12.4701L18.25 11.7201L20.45 10.6201C20.9 10.3901 21.42 10.4101 21.85 10.6801C22.27 10.9401 22.53 11.4002 22.53 11.9002Z'
          fill='#292D32'
        />
        <path
          d='M18.11 9.90997L16.63 10.7L7.12 5.34998L8.69 4.5L17.87 9.67999C17.97 9.73999 18.05 9.81997 18.11 9.90997Z'
          fill='#292D32'
        />
        <path
          d='M18.25 11.7197V13.9897C18.25 14.3997 17.91 14.7397 17.5 14.7397C17.09 14.7397 16.75 14.3997 16.75 13.9897V12.4697L18.25 11.7197Z'
          fill='#292D32'
        />
      </g>
    </svg>
  );
};

export default InventryInactiveIcon;
